var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventTimeOffGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1665 17.1165L16.9499 15.8999L5.0082 3.9582L1.7082 0.658203L0.658203 1.7082L2.9082 3.9582H2.37487C1.44987 3.9582 0.716536 4.69987 0.716536 5.62487L0.708203 14.7915C0.708203 15.7165 1.44987 16.4582 2.37487 16.4582H15.4082L17.1165 18.1665L18.1665 17.1165ZM17.3332 5.62487C17.3749 4.69987 16.6332 3.9582 15.7082 3.99987H12.3749V2.29154C12.3749 1.36654 11.6332 0.62487 10.7082 0.666536H7.37487C6.44987 0.62487 5.7082 1.36654 5.7082 2.29154V2.5582L17.3332 14.2249V5.62487ZM10.7082 3.99987H7.3332V2.29154H10.7082V3.99987Z",
    fill: "#AFAFAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventTimeOffGray);
export default __webpack_public_path__ + "static/media/event-time-off-gray.520a86c0e4d50e2349b32b10debdbe96.svg";
export { ForwardRef as ReactComponent };